import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isConversationalChatSetting = objectOf({
  enabled: boolean,
  opening_message: string,
  conversational_workflow_ids: arrayOf(string),
  app_ids: arrayOf(string),
});

export const isConversationalSettingsResult = objectOf({
  result: objectOf({
    brand_guideline_id: anyOf(string, nullOrUndefined),
    chat_setting: anyOf(isConversationalChatSetting, nullOrUndefined),
  }),
});
